import { ExportTemplate, FileTemplateExport } from '@icons';
import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import DownloadTemplateButton from './DownloadTemplateButton';

type TemplateToExportType = { label: string; value: string };
interface ExportTemplateModalProps {
	templatesToExport: TemplateToExportType[];
}

const ExportTemplateModal: React.FC<ExportTemplateModalProps> = ({ templatesToExport }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	const getDescriptionByValue = (value: string) => {
		switch (value) {
			case 'contracts':
				return 'Scarica il modello Excel relativo ai dati degli incarichi e atti di attingimento associati al progetto. Il file resistuisce le informazioni già caricate in piattaforma e può essere usato per aggiornamenti o backup.';
			case 'invoices':
				return 'Scarica il modello Excel relativo ai dati delle fatture associate al progetto. Il file resistuisce le informazioni già caricate in piattaforma e può essere usato per aggiornamenti o backup.';
			case 'payments':
				return 'Scarica il modello Excel relativo ai dati dei pagamenti associati al progetto. Il file resistuisce le informazioni già caricate in piattaforma e può essere usato per aggiornamenti o backup.';
			case 'timesheets':
				return 'Scarica il modello Excel relativo ai dati del personale associato al progetto. Il file resistuisce le informazioni già caricate in piattaforma e può essere usato per aggiornamenti o backup.';
			default:
				return 'UNKNOWN KEY';
		}
	};

	return (
		<>
			<Button
				onClick={() => {
					setIsModalOpen(true);
				}}
				className="btn custom-primary-button"
				style={{
					display: 'flex',
					gap: '0.5rem',
					fontWeight: 500,
					alignItems: 'center',
					height: '48px',
					padding: '12px 24px',
				}}
			>
				<ExportTemplate />
				<span>Esporta template</span>
			</Button>
			<Modal
				show={isModalOpen}
				onHide={() => {
					setIsModalOpen(false);
				}}
				centered
				size="lg"
				className="custom-scrollable_body-modal"
			>
				<Modal.Header
					style={{
						justifyContent: 'center',
						padding: '1.5rem',
					}}
				>
					<Modal.Title
						style={{
							display: 'grid',
							gap: '1rem',
							justifyItems: 'center',
						}}
					>
						<FileTemplateExport
							style={{
								fill: 'var(--np-text-primary-color)',
							}}
						/>
						<h5
							style={{
								fontSize: '24px',
								fontWeight: 700,
								marginBottom: 0,
							}}
						>
							Esporta Template
						</h5>
						<p
							style={{
								fontSize: '18px',
								fontWeight: 400,
								marginBottom: 0,
							}}
						>
							Scegli il template di cui hai bisogno
						</p>
					</Modal.Title>
				</Modal.Header>

				<Modal.Body style={{ display: 'grid', gap: '1rem', overflowY: 'auto' }}>
					{templatesToExport.map((template) => (
						<div
							key={template.value}
							style={{
								borderRadius: '8px',
								padding: '1rem',
								border: '1px solid #2A3A64',
								display: 'grid',
								gap: '3em',
								gridTemplateColumns: '1fr auto',
							}}
						>
							<div style={{ display: 'grid', gap: '0.5rem' }}>
								<p
									style={{
										marginBottom: 0,
										fontWeight: 700,
									}}
								>
									Template {template.label}
								</p>
								<p
									style={{
										marginBottom: 0,
									}}
								>
									{getDescriptionByValue(template.value)}
									{/* Lorem ipsum dolor sit, amet consectetur adipisicing elit. Asperiores, hic, animi sed commodi tenetur illum sapiente iusto,
									corporis voluptates nihil esse! Officiis, dolor expedita animi velit blanditiis ea iure maxime! */}
								</p>
							</div>
							<div
								style={{
									display: 'grid',
									placeContent: 'center',
								}}
							>
								<DownloadTemplateButton template={template} />
							</div>
						</div>
					))}
				</Modal.Body>
				<Modal.Footer>
					<Button
						className="btn custom-outline-button"
						style={{
							height: '48px',
						}}
						onClick={() => {
							setIsModalOpen(false);
						}}
					>
						Annulla
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
};

export default ExportTemplateModal;
